import { useAppDispatch, useAppStore } from "@/global/store";
import { selectSelectedPack } from "@/global/store/data/purchaseSeats/packs";
import React from "react";
import { useCongratsModal } from "./useCongratsModal";
import {
  eventsState,
  selectEventsSelected,
} from "@/global/store/data/purchaseSeats/events";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import {
  findUnacceptedBonusEventsSelected,
  findUnlockedBonusEvents,
} from "../packs.utils";

export function BonusUnlocker() {
  const teamConfig = useTeamConfig();
  const dispatch = useAppDispatch();
  const selectedPack = useAppStore(selectSelectedPack);
  const selectedBucket = selectedPack?.buckets[0];
  const congratsModal = useCongratsModal();
  const selectedEvents = useAppStore(selectEventsSelected);

  const unlockedBonusEvents = findUnlockedBonusEvents({
    teamConfig,
    events: selectedBucket?.events || [],
    selectedEvents,
    selectedPack,
    selectedBucket,
  });

  const unacceptedBonusEvents = findUnacceptedBonusEventsSelected({
    teamConfig,
    selectedEvents,
    selectedPack,
    selectedBucket,
  });

  React.useEffect(() => {
    if (unlockedBonusEvents?.length > 0) {
      dispatch(eventsState.actions.addSelectionMultiple(unlockedBonusEvents));
      congratsModal.fire({
        events: unlockedBonusEvents,
        title: selectedPack?.unlockBonus?.congratsModal?.title,
        description: selectedPack?.unlockBonus?.congratsModal?.description,
      });
    }
  }, [unlockedBonusEvents?.length]);

  React.useEffect(() => {
    if (unacceptedBonusEvents?.length > 0) {
      const eventCodes = unacceptedBonusEvents.map((event) => event.eventCode);
      dispatch(eventsState.actions.removeEventMulti(eventCodes));
    }
  }, [unacceptedBonusEvents?.length]);

  return <></>;
}
